import { FC, JSX } from "react";
import { Box, Avatar, Flex, Heading, Text } from "@radix-ui/themes";
import { Profile } from "@/models/Profile.model";

import {
  defaultCountries,
  FlagImage,
  parseCountry,
} from "react-international-phone";

const ProfileAbout: FC<Partial<Profile>> = ({
  firstName,
  lastName,
  avatarURL,
  countryOfResidence,
  nationality,
}): JSX.Element => {
  const userCountry = defaultCountries.find((item) => {
    const parsedCountry = parseCountry(item);
    return parsedCountry?.iso2 === countryOfResidence;
  });

  const userNationality = defaultCountries.find((item) => {
    const parsedCountry = parseCountry(item);
    return parsedCountry?.iso2 === nationality;
  });

  const livingInSameCountry = userNationality === userCountry;

  return (
    <Box
      style={{
        transform: "translateY(-48px)",
        marginBottom: "-48px",
      }}
    >
      <Flex direction="column" gap="4">
        <Avatar
          variant="solid"
          size="7"
          src={avatarURL ? avatarURL + "&tr=w-200,h-200,q-70" : ""}
          fallback={firstName ? firstName.slice(0, 1) : "A"}
        />
        <Flex direction="column" gap="1">
          <Heading m="0" as="h1">
            {firstName} {lastName}
          </Heading>
          <Text as="p" m="0" size="2" color="gray">
            {livingInSameCountry ? (
              <>
                {userNationality && (
                  <Flex gap="2" align="center">
                    <FlagImage size="16px" iso2={userNationality[1]} />
                    <Text size="2" as="span" color="gray">
                      {userNationality[0]}
                    </Text>
                  </Flex>
                )}
              </>
            ) : (
              <Flex gap="1" align="center">
                <Text size="2" as="span" color="gray">
                  From
                </Text>
                {userNationality && (
                  <Flex gap="1" align="center">
                    <FlagImage size="16px" iso2={userNationality[1]} />
                    <Text size="2" as="span" color="gray">
                      {userNationality[0]}
                    </Text>
                  </Flex>
                )}
                <Text size="2" as="span" color="gray">
                  living in
                </Text>
                {userCountry && (
                  <Flex gap="1" align="center">
                    <FlagImage size="16px" iso2={userCountry[1]} />
                    <Text size="2" as="span" color="gray">
                      {userCountry[0]}
                    </Text>
                  </Flex>
                )}
              </Flex>
            )}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ProfileAbout;
